import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers


import { P403Component,P404Component,P500Component } from 'basecomponents';
import { LoginComponent } from './auth/login/login.component';
//import { AuthGuard } from './helpers';
import { AuthGuard } from 'baseauth';
import { FileUploadViewComponent } from 'guploadmgr';

import { IPermissionGuardModel } from 'baseauth';
import { DefaultLayoutComponent } from './views/home';
import { ControlEnum } from 'solar-bo';
import { MainHostComponent } from './solar/mainhost/mainhost.component';
import { EmptyViewComponent } from './views/emptyview/emptyview.component';

//TODO: revisar las rutas con respecto a solar.routing
//TODO: Hay que añadir la url por defecto para los usuarios que no tienen acceso al dashboard. De momento que vayan a una pagina en blanco

export const routes: Routes = [
   {
    path: '',
    redirectTo: 'solar/dashboard',
    pathMatch: 'full',
  }
  , 
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
    {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivateChild: [AuthGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'main',
        component: MainHostComponent,
        data: {
          title: 'MainHostComponent'
        }
      },
      {
        path: 'solar403',
        component: P403Component,
        data: {
          title: 'Page 403'
        }
      }
      ,{
        path: 'uploadsrv',
        canActivate: [AuthGuard],
        component: FileUploadViewComponent
        , pathMatch: 'full'
        , data: {
          title: 'Load module'
        }
      },
      {
        path: 'users',
        canActivate: [AuthGuard]
        , data: {
          title: 'Solar Users', Permission: {
            resourceId: ControlEnum.SEC_ADMIN,
            RedirectTo: 'solar403'
          } as IPermissionGuardModel
        },
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'verifiers',
        canActivate: [AuthGuard]
        , data: {
          title: 'Solar Verifiers', Permission: {
            resourceId: ControlEnum.SEC_ADMIN,
            RedirectTo: 'solar403'
          } as IPermissionGuardModel
        },
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () => import('@solar/solar/solar-main.module').then(m => m.SolarMainModule)
        , data: {
          title: 'Main DashBoard', shouldReuse: true, Permission: {
            resourceId: ControlEnum.SEC_DASHBOARD,
            RedirectTo: 'main'
          } as IPermissionGuardModel
        }
      },
      {
        path: 'solar'
        ,loadChildren: () => import('@solar/solar/solar-main.module').then(m => m.SolarMainModule)
      }

    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes
//,{ enableTracing: true } // <-- debugging purposes only
, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
